import React, { useMemo } from "react"
import { useSettings } from "../../hooks/useSettings"

export const withFooterSocialLinks = Component =>
  React.memo(({ name = "FooterSocialLinks" }) => {
    const {
      social: { channels: items },
    } = useSettings()

    const titles = {
      instagram: "IG",
      facebook: "FB",
    }

    const convertTitle = title => {
      if (title && titles[title]) {
        return titles[title]
      }

      if (title && title.length > 0) {
        return title.substring(0, 2).toUpperCase()
      }

      return "NA"
    }

    const mappedItems = items.map(item => ({
      title: convertTitle(item?.title),
      url: item?.url,
    }))

    const handleClick = item => {
      window.open(item?.url, "_blank")
    }

    Component.displayName = name
    return useMemo(() => <Component items={mappedItems} onClickButton={handleClick} />, [mappedItems])
  })
